import * as React from 'react'

const SvgHeartFill = props => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.265C13.206 2.82 14.944 1.994 16.768 2c3.276-.024 6.003 2.644 6.225 6.09.097 2.129-.7 4.194-2.178 5.648-1.719 1.907-7.564 7.617-7.814 7.86a1.442 1.442 0 01-1.998 0c-.27-.243-6.115-5.9-7.854-7.86C1.685 12.277.903 10.212 1.01 8.09 1.23 4.644 3.96 1.976 7.235 2c1.824-.006 3.562.82 4.766 2.265z"
      fill="#231815"
    />
    <mask
      id="HeartFill_svg__a"
      maskUnits="userSpaceOnUse"
      x={1}
      y={2}
      width={22}
      height={20}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4.265C13.206 2.82 14.944 1.994 16.768 2c3.276-.024 6.003 2.644 6.225 6.09.097 2.129-.7 4.194-2.178 5.648-1.719 1.907-7.564 7.617-7.814 7.86a1.442 1.442 0 01-1.998 0c-.27-.243-6.115-5.9-7.854-7.86C1.685 12.277.903 10.212 1.01 8.09 1.23 4.644 3.96 1.976 7.235 2c1.824-.006 3.562.82 4.766 2.265z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#HeartFill_svg__a)">
      <path fill="#1B1B1B" d="M1 1h22v22H1z" />
    </g>
  </svg>
)

export default SvgHeartFill
